export default "__VITE_ASSET__B1t5YhHs__"